var map = {
	"./23rd Kongu Trophy at Kongu Engineering College, Perundurai  ON 26.9.2024.jpg": 61465,
	"./24th Kongu Trophy at Kongu Engineering College, Perundurai on 26.9.2025 to 28.9.2025.JPG": 54123,
	"./37th Graduation Day at Kongu Engineering College, Perundurai  ON 12.1.2025.jpg": 42042,
	"./40th Annual Day Function at Kongu Engineering College, Perundurai  ON 27.3.2024.jpg": 33480,
	"./40th Sports Day Celebrations at Kongu Engineering College, Perundurai  ON 25.3.2024.jpg": 50087,
	"./41st  Sports Day Celebrations at KEC on 19.3.2025.JPG": 61298,
	"./41st Annual Day Celebrations at KEC on 20.3.2025.JPG": 45350,
	"./41st Batch of B.E.B.Tech and 10th Batch of B.Arch First Year Inaugural Function at Kongu Engineering College, Perundurai  ON 30.8.2024.png": 52364,
	"./42nd Batch of B.E.B.Tech and 11th Batch of B.Arch First Year Inaugural Function at KEC on 11.8.2025.JPG": 17704,
	"./AICTE ATAL-sponsored two-week Advanced Faculty Development Program (FDP) on Advancing Healthcare and Med-Tech through Machine Learning on 13.2.2025.jpg": 77172,
	"./Academic Excellence Award Function at Kongu Engineering College, Perundurai  ON 25.5.2024.jpg": 23421,
	"./Academic Excellence Award Function at Kongu Engineering College, Perundurai on 15.3.2025.JPG": 90372,
	"./Erode Varnam Vizha Valedictory Session & Inauguration of CII - YI YUVA KEC club on 16.09.2025.jpeg": 28166,
	"./Founders Day Celebration of Kongu Vellalar Institute of Technology Trust at KEC on 23.8.2025.JPG": 67786,
	"./Founders Day of the Kongu Vellalar Institute of Technology Trust  ON 17.8.2024.jpg": 45484,
	"./Grand Guest Lecture on Entrepreneurship Journey - Idhayam Global Brand by Thiru.V.R.Muthu CEO, Idhayam Family on 6.10.2025.jpeg": 10076,
	"./Grand Interactive Meeting with CEO of ZOHO Corporation at Kongu Engineering College, Perundurai ON 21.9.2024.jpg": 73608,
	"./Independence Day Celebrations at KEC on 15.8.2025.JPG": 81810,
	"./KEC Inaugurates Delphi TVS Centre of Excellence in Advanced Fuel Injection Systems on 3.10.2025.JPG": 30597,
	"./Kongu Engineering College Students Bagged 7 Lakhs Cash Prize in International KPIT-Sparkle Contest ON 7.3.2024.png": 10270,
	"./Kongu Engineering College Students Bagged Best Acceleration Award in SIEP E-BIKE CHALLENGE, IES University, Bhopal ON 30.1.2024.jpg": 31849,
	"./Kongu Engineering College Students Won Vimarsh 5G Hackathon Runner-Up Award from Union Home Secretary, Government of India ON 14.3.2024.jpg": 47362,
	"./Kongu Engineering College, Perundurai Hosted ICWA Sponsored International Conference on Indias Foreign Policy ON 30.1.2025.jpg": 23848,
	"./Kongu Engineering College, Perundurai Inked MoU with  Current Electro Mech Pvt Ltd, Erode on 20.2.2026.jpeg": 91490,
	"./Kongu Engineering College, Perundurai Inked MoU with Adani Cement on 10.10.2025.jpeg": 53861,
	"./Kongu Engineering College, Perundurai Inked MoU with Allwin Pipes, Vijayamangalam on 23.1.2026.jpeg": 14349,
	"./Kongu Engineering College, Perundurai Inked MoU with Coral Manufacturing Works, Erode on 9.4.2025.jpg": 44512,
	"./Kongu Engineering College, Perundurai Inked MoU with Delphi-TVS Technologies, Chennai on 16.5.2025.JPG": 74534,
	"./Kongu Engineering College, Perundurai Inked MoU with Gdansk University of Technology on 25.9.2025.jpg": 29724,
	"./Kongu Engineering College, Perundurai Inked MoU with Leister Technologies India Pvt. Ltd, Chennai on 23.1.2026.JPG": 7862,
	"./Kongu Engineering College, Perundurai Inked MoU with RobotoAI Technologies Pvt Ltd on 15.11.2025.jpeg": 37789,
	"./Kongu Engineering College, Perundurai Inks MoU with Haddington Wines & Whiskies, Scotland  ON 22.2.2024.jpg": 4833,
	"./Kongu Engineering College, Perundurai Triumph at Smart India Hackathon (SIH) 2024 with Five Prestigious Wins ON 15.1.2024.jpg": 95686,
	"./National Conference on Innovations in English Language and Literature at Kongu Engineering College, Perundurai on 7.3.2025.jpg": 66726,
	"./Pongal Celebrations at Kongu Engineering College Perundurai  ON 11.1.2025.jpg": 56735,
	"./Republic Day Celebrations at Kongu Engineering College, Perundurai  ON 26.1.2024.jpg": 92087,
	"./Silver Jubilee Meet at KEC on 2.8.2025.JPG": 4097,
	"./Startup Mania 9.0 Erode-Entrepreneurship Conclave and Award Ceremony held at Kongu Engineering College, Perundurai ON 7.12.2024.jpg": 40212,
	"./Techno - Cultural Fest Celebrations at KEC on 21.8.2025 & 22.8.2025.JPG": 80938
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50117;